/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { CHARLIMIT_HOMEPAGE } from '../../const';
import useMediaQuery from '../../hooks/useMediaQuery';
import Button from '../Button';
import OnboardingCriteria from '../OnboardingCriteria';
import Text from '../Text';
import useStyles from './styles';

const Hero = ({
  textSize = 1,
  text,
  images,
  overlayVariation = 4,
  ctaText,
  ctaText1,
  ctaId1,
  ctaId2,
  wrapperId,
  ctaOnClick,
  isOnBoardingCriteriaIncluded = false,
  scrolldirectionContext,
  isHomePage = false,
  isHomePage1 = false,
  headerHeight,
  isRec = false,
  ...rest
}) => {
  const styles = useStyles();
  const hasCta = ctaText && ctaOnClick;
  const [hasLoaded, setHasLoaded] = useState(false);
  const { main, secondary, main1, secondary1, secondary2 } = text;
  const MQtoHideQuickLinks = useMediaQuery('screen and (max-width: 600px)');

  useEffect(() => {
    setTimeout(() => {
      setHasLoaded(true);
    }, 300);
  }, []);
  return (
    <div
      id={wrapperId}
      css={styles.hero(
        images,
        overlayVariation,
        scrolldirectionContext,
        headerHeight,
        isRec,
        MQtoHideQuickLinks
      )}
      {...rest}
    >
      <div
        data-test-id="hero-text"
        css={styles.textWrapper(hasLoaded)}
        {...rest}
      >
        {main && (
          <Text
            as="h1"
            size={textSize}
            css={styles.mainText(isHomePage)}
          >
            {main}
          </Text>
        )}
        {main1 && (
          <div css={styles.mainTextNearme}>
            <Text as="h1" size={textSize} css={styles.mainText1(isHomePage1)}>
              {main1}
            </Text>
            <hr css={styles.redline}></hr>
            <hr css={styles.orangeline}></hr>
          </div>
        )}

        {secondary && (
          <Text css={styles.secondaryText}>
            {secondary?.substring(0, CHARLIMIT_HOMEPAGE)}
          </Text>
        )}
        {hasCta && (
          <Button
            primary
            id={ctaId1}
            css={styles.cta}
            onClick={() => ctaOnClick(true)}
            role="button"
            tabIndex={0}
          >
            {ctaText}
          </Button>
        )}

        {secondary1 && (
          <Text css={styles.secondaryText1}>
            {secondary1?.substring(0, CHARLIMIT_HOMEPAGE)}
          </Text>
        )}
        {secondary2 && (
          <Text css={styles.secondaryText2}>
            {secondary2?.substring(0, CHARLIMIT_HOMEPAGE)}
          </Text>
        )}
        {hasCta && (
          // <Text id={ctaId} css={styles.cta1} onClick={() => ctaOnClick()} role="button" tabIndex={0}>
          //   {ctaText1}
          // </Text>
          <Button
            id={ctaId2}
            css={styles.cta1}
            onClick={() => ctaOnClick()}
            role="button"
            tabIndex={0}
          >
            {ctaText1}
          </Button>
        )}
        {isOnBoardingCriteriaIncluded && <OnboardingCriteria />}
      </div>
    </div>
  );
};

Hero.prototype = {
  textSize: PropTypes.number,
  text: PropTypes.object,
  images: PropTypes.object,
  overlayVariation: PropTypes.number,
  ctaText: PropTypes.string,
  ctaId: PropTypes.string,
  wrapperId: PropTypes.string,
  ctaOnClick: PropTypes.func,
  isOnBoardingCriteriaIncluded: PropTypes.bool,
  scrolldirectionContext: PropTypes.string,
  isHomePage: PropTypes.bool,
  headerHeight: PropTypes.string,
  isRec: PropTypes.bool,
};

export default Hero;
